var url = location.href;
var url_static = "https://invictavenezuela.com/";

var url = location.href;
var host = window.location.host;


if(url == url_static && localStorage.getItem("subscription") == undefined && sessionStorage.getItem("subscription") == undefined){
	if(url == "https://"+host+"/"){
	$(document).ready(function(){
      
  		$("#modalNewsletter").css("display", "flex");
      
    })  
	}
}

if(url == url_static+"?customer_posted=true#contact_form"){
	$("#modalNewsletter").css("display", "none");
  	$("#modalSuccess").css("display", "flex");
    localStorage.setItem("subscription", "yes");
}

if(url == url_static+"?contact%5Btags%5D=newsletter&form_type=customer#ContactFooter" || url == url_static+'?contact%5Baccepts_marketing%5D=on&contact%5Btags%5D=newsletter&form_type=customer#contact_form'){
	$("#modalNewsletter").css("display", "none");
  	$("#modalSuccess").css("display", "flex");
    localStorage.setItem("subscription", "yes");
}

$('.modal-dialog').click(function (e) {
    e.stopPropagation();
});

$("#modalNewsletter").click(function() {
    $("#modalNewsletter").css("display", "none");
});

$("#btn-subscription-modal").click(function(){
	$("#modalNewsletter").css("display", "none");
  sessionStorage.setItem("subscription", "yes");
});

$("#modalError").click(function() {
    $("#modalError").css("display", "none");
  	location.href= url_static;
});

$("#modalSuccess").click(function() {
    $("#modalSuccess").css("display", "none");
  	location.href=url_static;
  	localStorage.setItem("subscription", "yes");
});

$("#omitir").click(function() {
    $("#modalNewsletter").css("display", "none");
  	sessionStorage.setItem("subscription", "yes");
});

$("#btn-success-modal").click(function(){
	$("#modalSuccess").css("display", "none");
  	location.href=url_static;
  	localStorage.setItem("subscription", "yes");
});

$("#btn-error-modal").click(function(){
	$("#modalError").css("display", "none");
  	location.href=url_static;
});

$("#carouselExampleIndicators").mouseover(function(){
  $(".carousel-control-prev").attr("style", "display: flex !important");
  $(".carousel-control-next").attr("style", "display: flex !important");
});

$("#carouselExampleIndicators").mouseleave(function(){
  $(".carousel-control-prev").attr("style", "display: none !important");
  $(".carousel-control-next").attr("style", "display: none !important");
});


